
import React, { Component } from "react";

class TerrainHighlights extends Component{

    constructor(props){
        super(props)
            }
    render(){
        const ars = [];
        console.log('############### this.props.amenities')
        console.log(unescape(this.props.highlights))

        
      


       
        return (

            <p>{this.props.highlights}</p>
        )
    }
   
}

export default TerrainHighlights;